import { APP_BASE_URL } from "@/constants/Configs";
import { storageUtils } from "@/utils";

type UseSubscriptionPaymentOptions = {
  onSuccess?: () => Promise<void> | void;
};

const useSubscriptionPayment = ({
  onSuccess,
}: UseSubscriptionPaymentOptions) => {
  const requestSubscription = async () => {
    const sessionId = storageUtils.getSessionId();
    const popup = window.open(
      `${APP_BASE_URL}/pay?sessionId=${sessionId}&redirectUrl=localhost:8081`,
      "paymentPopup",
      "width=500,height=600"
    );
    const handleMessage = (event: any) => {
      if (event.origin !== APP_BASE_URL) return;
      if (event.data?.type === "payment-success") {
        popup?.close();
        onSuccess?.();
      }
      if (event.data?.type === "payment-cancel") {
        popup?.close();
      }
    };
    window.addEventListener("message", handleMessage);
    const interval = setInterval(() => {
      if (popup?.closed) {
        clearInterval(interval);
        window.removeEventListener("message", handleMessage);
      }
    }, 500);
    return;
  };
  return { requestSubscription };
};

export default useSubscriptionPayment;
